import { useLanguageContext } from "../../../context/LanguageContext";
import PrintersPage from "../../../pages/printers/index/PrintersPage";
import { usePrintersRouteValidator } from "../../validators/printers/PrintersRouteValidator";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePrintersRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/printers")
    .setLabel(translate("eva.main.entities.printers"))
    .setValidator(usePrintersRouteValidator())
    .setPage(<PrintersPage />);
}

export default usePrintersRouteConfig;
